class FooterMenu extends HTMLElement {
    constructor() {
        super();
        this.firstLevelMenu = this.querySelectorAll('details');
        this.firstLevelMenuSummary = this.querySelectorAll('details summary');
        this.mobileQuery = window.matchMedia('(min-width: 1000px)').matches;
        this.cachedWidth = window.innerWidth;

        if (!this.mobileQuery) {
            this.firstLevelMenu.forEach(element => element.removeAttribute('open')); 
        }
        this.resizeHandler();
    }
    connectedCallback() {
        const self = this;
        this.firstLevelMenu.forEach(function(element, index, array) {
            element.addEventListener('click', function(event){
                if (self.mobileQuery && element.hasAttribute('open')) {
                    if (!event.target.closest('a')) { 
                        event.preventDefault();
                    }
                }
                else {
                    if(!event.currentTarget.hasAttribute('open')) {
                        self.firstLevelMenu.forEach(element => element.removeAttribute('open'));
                    }
                }
            })
        })
    }
    
    resizeHandler() {
        window.addEventListener('resize', () => {
            let newWidth = window.innerWidth;
            if (this.cachedWidth != newWidth) {
                if (window.matchMedia('(min-width: 1000px)').matches) {
                    this.mobileQuery = true;
                    this.firstLevelMenu.forEach(element => element.open="true");
                }
                else {
                    this.mobileQuery = false;
                    this.firstLevelMenu.forEach(element => element.removeAttribute('open'));
                }
                
                this.cachedWidth = newWidth;
            }
        });
    }
}

customElements.define("footer-menu", FooterMenu);